export default (figures = []) => {
  return figures;
};
